<template>
    <a :class="scrollMarkClass" class="e2e-scroll-mark" />
</template>

<script>
import { SCROLL_MARK_CLASS } from "../layout-bom";
export default  {
  name: "fragment-scroll-mark",
  props: ["fragment"],
  data() {
    return {
      scrollMarkClass: SCROLL_MARK_CLASS
    };
  }
};
</script> 